












































































import { mapActions, mapGetters } from 'vuex';

import { ALForm } from '@/common/component.types';

import { diffDeep, setErrorFromAxiosError } from '@/utils/helpers';

import { IWorkflow, IWorkflowData, Workflow } from '@/models';
import { SystemError } from '@/models/error/error';
import { ISystemError } from '@/models/error/error.types';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';
import snackbarMixin from '@/mixins/snackbar';

import ALDialog from '@/components/core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

const baseMixins = mixins(authMixin, snackbarMixin);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'WorkflowFormDialog',
    components: {
      ALDialog,
      ErrorAlert
    },

    data() {
      return {
        dialog: false,
        isLoading: false,
        isEdit: false,
        isFormValid: false,

        workflowData: {} as IWorkflowData,

        tags: [] as number[],
        error: null as ISystemError | null
      };
    },

    computed: {
      ...mapGetters({
        getWorkflowById: 'workflow/getWorkflowById'
      })
    },

    methods: {
      ...mapActions({
        createWorkflow: 'workflow/createWorkflow',
        updateWorkflow: 'workflow/updateWorkflow'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(workflow?: IWorkflow) {
        this.clearErrors();
        this.resetFormValidation();
        this.isEdit = !!workflow;

        this.workflowData = this.isEdit
          ? new Workflow(workflow!)
          : ({} as IWorkflowData);

        this.dialog = true;
      },

      close() {
        this.dialog = false;
      },

      clearErrors() {
        this.error = null;
      },

      save() {
        this.clearErrors();
        const valid = this.validateForm();

        if (valid) {
          let workflowInstance: IWorkflow | null = null;

          try {
            workflowInstance = new Workflow(this.workflowData);
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }

          if (workflowInstance != null) {
            this.isLoading = true;

            const payloadDelta = this.isEdit
              ? diffDeep(
                  workflowInstance,
                  this.getWorkflowById(workflowInstance.id),
                  true
                )
              : workflowInstance;
            const saveAction = this.isEdit
              ? this.updateWorkflow
              : this.createWorkflow;

            return saveAction(payloadDelta)
              .catch(error => {
                this.error = setErrorFromAxiosError(error);
              })
              .then((workflowId: number) => {
                if (!this.isEdit) {
                  this.routeToWorkflowPage(workflowId).then(() => {
                    this.createSnack({
                      color: 'success darken-1',
                      type: 'info',
                      right: true,
                      msg: 'Workflow created',
                      timeout: 4000
                    });
                  });
                } else {
                  this.close();
                }
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        }
      },

      routeToWorkflowPage(workflowId: number) {
        return this.$router.push({
          name: 'workflow-detail',
          params: {
            id: String(workflowId)
          }
        });
      }
    }
  });
